import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientPortalOverviewValue',
})
export class ClientPortalOverviewValuePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(value: any, ...args: any[]): any {
    if (typeof value === 'string') {
      return value;
    }

    return this.datePipe.transform(value, 'MM-dd-yyyy') || '';
  }
}
